module.exports = __webpack_public_path__ + "img/user.d8a10296.png";